import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { RiComputerLine } from "react-icons/ri";
import fetchDataArps from "../../../services/fetchDataArps";
import ComputerPanel from "./ComputerPanel";

export default function ComputerWidget() {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [expenses, setExpenses] = useState<any>([]);
  const year = new Date().getFullYear();

  const handleFetchExpenses = async () => {
    const uri = `finance/transactions/expenses/computer?start=20220101&end=20221231`;
    const response = await fetchDataArps(uri);
    setExpenses(response?.payload);
  };

  useEffect(() => {
    handleFetchExpenses();
  }, []);

  return (
    <>
      <Tooltip title="Computer Running Costs">
        <button
          className="border px-3 py-1 flex justify-center items-center hover:bg-gray-100"
          onClick={() => setVisible(true)}
        >
          <div className="">
            <RiComputerLine size={20} />
          </div>
          <div className="mx-1 pb-1">Computer Running Costs</div>
        </button>
      </Tooltip>
      <ComputerPanel
        isVisible={isVisible}
        setVisible={setVisible}
        expenses={expenses}
        title={"Computer Running Costs"}
        year={year}
      />
    </>
  );
}
